// extracted by mini-css-extract-plugin
module.exports = {"content":"ResolutionEvent_content__3LY2s","fullWidth":"ResolutionEvent_fullWidth__5Y5KJ","compact":"ResolutionEvent_compact__XA2zG","details":"ResolutionEvent_details__vlB8a"};